import type {ExcludedProperties} from '@lexical/yjs';
import {RedactionNode} from 'components/DSYS/editor/nodes/RedactionNode';

const redactionExcludedProperties = new Set<string>(['__renderedAccessState']);

export const editorCollabExcludedProperties: ExcludedProperties = new Map([
  [RedactionNode, redactionExcludedProperties],
]);
